import { createAsyncThunk } from '@reduxjs/toolkit';

import { API } from '@/shared/api';
import { Project } from '@/shared/types/Project';

import { recalculateOverlappedTimestamps, setAllSegments, setServerSegments } from '../EditorSlice';

type TGetAllSegments = {
  projectId: Project['id'];
  shouldRecalculateOverlappedTimestamps?: boolean;
  shouldUpdateOnlyServerSegments?: boolean;
};

export const getAllSegments = createAsyncThunk(
  'editor/getAllSegments',
  async (
    { projectId, shouldRecalculateOverlappedTimestamps, shouldUpdateOnlyServerSegments }: TGetAllSegments,
    { dispatch, rejectWithValue },
  ) => {
    try {
      const { segments } = await API.getSegments(projectId);

      if (shouldUpdateOnlyServerSegments) {
        dispatch(setServerSegments(segments));
      } else {
        dispatch(setAllSegments(segments));
      }

      if (shouldRecalculateOverlappedTimestamps) {
        dispatch(recalculateOverlappedTimestamps());
      }
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
